import React, { PropTypes } from 'react';

import { NitroParagraph, NitroModal } from 'nitro-components';

import { CHANGE_COSTCENTER_HEADING, CHANGE_COSTCENTER_HINT } from '../content';

const ConfirmChangesModal = ({ open, close, disabled, action }) => {
  return (
    <NitroModal variant="primary" action={action} close={close} disabled={disabled} isOpen={open} title={CHANGE_COSTCENTER_HEADING}>
      <NitroParagraph align="center">{CHANGE_COSTCENTER_HINT}</NitroParagraph>
    </NitroModal>
  );
};

ConfirmChangesModal.propTypes = {
  close: PropTypes.func.isRequired,
  action: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  disabled: PropTypes.bool
};

export default ConfirmChangesModal;



// WEBPACK FOOTER //
// ./src/features/relocations/vehicle/components/ConfirmChangesModal.js